import { CodeInvoiceStatus, CodeStatus } from '../../../../../entities/shared/code';
import { InvoiceStatus } from '../../../../../entities/invoicing/invoicing.enum';
import { TaxInclusiveOption } from '../../../../../entities/purchase/purchase.order.line';
import { InvoiceMergeData } from '../../data/invoice.merge.data';
import { DateTime } from 'luxon';
import { CurrencyFormatter } from '../../../../../utilities/currency.formatter';


export class FakeInvoiceMergeData extends InvoiceMergeData {

    constructor() {
        super();


        this._id = '0c573a9a-a442-4d40-865b-b2225e13b41d';
        this.invoiceNumber = 'INV1000';
        this.status = InvoiceStatus.Approved;

        this.invoiceDate = DateTime.local().toFormat('dd/MM/yyyy');
        this.dueDate = DateTime.local().plus({ days: 30 }).toFormat('dd/MM/yyyy');
        this.generatedDate = this.invoiceDate;
        this.lastIssuedDate = this.invoiceDate;
        this.lastPaymentDate = this.dueDate;
        this.customerReference = 'CR12345';
        this.version = '1';
        this.notes = 'Sed dapibus, erat nec dignissim facilisis, velit ipsum lobortis orci, sed tincidunt tortor est ut sem. Etiam posuere aliquam enim id hendrerit.';
        this.taxInclusiveOption = TaxInclusiveOption.Exclusive;
        this.terms = 'Etiam posuere aliquam enim id hendrerit. Etiam vitae ultricies enim. Donec vel convallis sapien, tincidunt porta justo. Nunc magna urna, porta euismod est vitae, luctus sagittis nibh.';

        // this.fullAddress = JobUtility.address(address);

        this.createdBy = 'Finance User';
        this.createdAt = this.invoiceDate;
        this.updatedBy = 'Finance User';
        this.updatedAt = this.invoiceDate;
        this.timezone = 'Australia/Sydney';
        this.jobNumber = 'J1000';

        this.subTotal = CurrencyFormatter.formatCurrency(200, 2);
        this.tax = CurrencyFormatter.formatCurrency(20, 2);
        this.total = CurrencyFormatter.formatCurrency(220, 2);
        this.amountPaid = CurrencyFormatter.formatCurrency(100, 2);
        this.roundingAmount = CurrencyFormatter.formatCurrency(0, 2);
        this.outstandingAmount = CurrencyFormatter.formatCurrency(120, 2);

        this.lines = [
            {
                name: 'MANUAL',
                description: 'Quisque cursus vel ex eu imperdiet. Sed porta accumsan turpis. Aliquam elementum rutrum ipsum id congue.',
                quantity: 1,
                codeUoM: 'EACH',
                price: CurrencyFormatter.formatCurrency(0, 2),
                subTotal: CurrencyFormatter.formatCurrency(0, 2),
                tax: CurrencyFormatter.formatCurrency(0, 2),
                total: CurrencyFormatter.formatCurrency(0, 2),
                notes: 'Sed porta accumsan turpis.',
                location: 'Kitchen',
                status: CodeStatus.Normal,
                invoicingStatus: CodeInvoiceStatus.Billable,
                sortOrder: 0,
            },
            // {
            //     name: 'MANUAL',
            //     description: 'Quisque cursus vel ex eu imperdiet. Sed porta accumsan turpis. Aliquam elementum rutrum ipsum id congue.',
            //     quantity: '1',
            //     codeUoM: 'EACH',
            //     price: CurrencyFormatter.formatCurrency(200, 2),
            //     subtotal: CurrencyFormatter.formatCurrency(200, 2),
            //     tax: CurrencyFormatter.formatCurrency(20, 2),
            //     total: CurrencyFormatter.formatCurrency(220, 2),
            //     notes: 'Sed porta accumsan turpis.',
            //     location: 'Kitchen',
            //     status: CodeStatus.Normal
            // },
            {
                name: 'INSTALLATION',
                description: 'Sed mattis luctus ligula. Fusce vestibulum est in ultricies blandit. Vivamus dictum.',
                quantity: 1,
                codeUoM: 'EACH',
                price: CurrencyFormatter.formatCurrency(200, 2),
                subTotal: CurrencyFormatter.formatCurrency(200, 2),
                tax: CurrencyFormatter.formatCurrency(20, 2),
                total: CurrencyFormatter.formatCurrency(220, 2),
                notes: 'Sed porta accumsan turpis.',
                location: 'Kitchen',
                status: CodeStatus.Variation,
                invoicingStatus: CodeInvoiceStatus.Billable,
                sortOrder: 1,
            }
        ];

        this.linesNotZero = this.lines.slice(1);
    }

}
